import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import { commandWorkspaceCohortCollaboratorsSummary } from '../actions';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { accountOrTeamIds, collaboratorType, cohortId, permissionLevel } = action;

  const workspaceCohortPermissionGrant = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT_PERMISSION_GRANT,
    [`${collaboratorType}Ids`]: [accountOrTeamIds],
    cohortId,
    permissionLevel,
  });

  if (workspaceCohortPermissionGrant.type === constants.RTM_WORKSPACE_COHORT_PERMISSION_GRANT_OK) {
    yield put(commandWorkspaceCohortCollaboratorsSummary(cohortId));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: workspaceCohortPermissionGrant.message || <FormattedMessage {...messages.permissionGrantError} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_GRANT_PERMISSION_ON_COHORT, catchErrors, sendRequest, connection);
}
